/**
 * 系统管理-菜单管理-编辑页
 * luxinwen
 * 2022-08
 */
<template>
  <div>
    <Drawer class="drawer" :title="title" v-model="myValue" width="600" :before-close="beforeClose">
      <Form ref="editForm" :model="formData" :rules="formRule" :label-width="100">
        <FormItem label="所属系统">
          <Input v-model.trim="formData.merchantName" disabled />
        </FormItem>
        <FormItem label="上级菜单">
          <Input v-model.trim="formData.parentMenuName" disabled />
        </FormItem>
        <FormItem label="菜单名称" prop="menuName">
          <Input v-model.trim="formData.menuName" maxlength="50" clearable :disabled="isShow" />
        </FormItem>
        <FormItem label="菜单编码" prop="menuCode">
          <Input v-model.trim="formData.menuCode" maxlength="50" clearable :disabled="isShow" />
        </FormItem>
        <FormItem label="接口权限" prop="menuUrl">
          <Input v-model.trim="formData.menuUrl" type="textarea" :rows="5" placeholder="请输入接口权限；若无，请输入/即可" clearable :disabled="isShow"></Input>
        </FormItem>
      </Form>
      <div class="drawer-foot" v-show="!isShow">
        <Button type="primary" @click="submit">提交</Button>
      </div>
      <Spin size="large" fix v-if="isLoading"></Spin>
    </Drawer>
  </div>
</template>

<script>
  const formData = {
    isButtonControl: '',  // 按钮权限控制。0-启用，1-关闭
    isLeaf: '', // 是否为叶子节点，0:菜单，1:叶子节点
    menuCode: '', // 菜单编码
    menuName: '', // 菜单名称
    menuOrder: '',  // 菜单排序值，由大到小
    menuStatus: '', // 菜单状态。0-启用，1-关闭
    menuUrl: '',  // 菜单链接
    merchantCode: '', // 商户代码
    merchantName: '',
    parentMenuId: '', // 父菜单ID
    parentMenuName: '' // 父菜单名称
  };

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default() {
          return {};
        }
      },
      flag: {
        type: String
      }
    },
    data() {
      return {
        myValue: this.value,  // 是否显示抽屉
        isInit: false,        // 是否初始化
        isLoading: false,     // 是否加载中
        formData: Object.assign({}, formData),
        formRule: {
          menuName: [
            {
              required: true,
              message: '请输入菜单名称',
              trigger: 'blur'
            }
          ],
          menuCode: [
            {
              required: true,
              message: '请输入菜单编码',
              trigger: 'blur'
            }
          ],
          menuUrl: [
            {
              required: true,
              message: '请输入接口权限；若无，请输入/即可',
              trigger: 'blur'
            }
          ]
        },
        backupData: {}
      };
    },
    computed: {
      title() {
        return {
          'add': '新增',
          'show': '查看',
          'edit': '编辑'
        }[this.flag] + '菜单';
      },
      isEqual() {
        return this.deepEqual(this.formData, this.backupData);
      },
      isShow() {
        return this.flag === 'show';
      },
      isEdit() {
        return this.flag === 'edit';
      }
    },
    methods: {
      /**
       * 初始化数据
       */
      initData(data = {}, isInit = false) {
        this.formData = this.deepCopy(formData);
        Object.keys(this.formData).forEach(item => {
          if (data.hasOwnProperty(item)) {
            this.formData[item] = data[item];
          }
        });
        if (isInit) {
          this.$nextTick(() => {
            this.backupData = this.deepCopy(this.formData);
            this.isInit = true;
          });
        }
      },
      /**
       * 获取数据
       */
      getData() {
        this.initData(this.data, true);
      },
      /**
       * 关闭前的回调
       */
      beforeClose() {
        return new Promise((resolve, reject) => {
          if (!this.isInit) {
            // 如果未初始化时快速点击关闭，则不做处理
          } else if (this.isEqual) {
            this.myValue = false;
          } else {
            this.$confirm('数据变更后未保存，是否直接关闭？').then(() => {
              this.myValue = false;
            });
          }
        });
      },
      /**
       * 提交
       */
      submit() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm('确定要提交吗？').then(() => {
              let url = this.$api.system.addMenu;
              let data = Object.assign({}, this.formData);
              if (!data.parentMenuId || data.parentMenuId === '') {
                data.parentMenuId = 0;
                data.isLeaf = 0;
              } else {
                data.isLeaf = 1;
              }
              if (this.isEdit) {
                url = this.$api.system.updateMenu;
                data.menuId = this.data.menuId;
              }
              this.save(url, data);
            });
          }
        });
      },
      /**
       * 保存
       */
      save(url, data) {
        this.$axios({
          url,
          data,
          beforeSend: () => {
            this.isLoading = true;
          },
          complete: () => {
            this.isLoading = false;
          }
        }).then(data => {
          this.notice({
            type: 'success',
            desc: '提交成功'
          });
          this.myValue = false;
          this.$emit('success');
        });
      }
    },
    watch: {
      value(val) {
        this.myValue = val;
        if (this.myValue) {
          // 获取数据
          this.getData();
          // 隐藏页面滚动条
          document.querySelector('body').classList.add('hidden');
          // 重置内容域滚动条
          this.$nextTick(() => {
            let $drawer = document.querySelector('.drawer .ivu-drawer-body');
            if ($drawer) $drawer.scrollTo(0, 0);
          });
        } else {
          // 清除表单验证效果
          this.$refs.editForm && this.$refs.editForm.resetFields();
          // 重置初始化状态
          this.isInit = false;
          // 恢复页面滚动条
          document.querySelector('body').classList.remove('hidden');
        }
      },
      myValue(val) {
        this.$emit('input', val);
      }
    }
  };
</script>